import React, { ChangeEvent, useEffect } from "react";
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { Box, InputLabel, OutlinedInput } from "@material-ui/core";
import SecondaryButton from "./SecondaryButton";
import { FormattedMessage, useIntl } from "react-intl";
import RegisterAddressFields from "./RegisterAddressFields";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    boxLine: {
      border: '1px solid #ebdcc6',
      borderRadius: '4px',
      boxShadow: 'none',
      padding: 10,
      backgroundColor: '#ffffff'
    },
    boxTitle: {
      paddingBottom: 10,
      paddingTop: 10,
      fontWeight: 'bold',
      fontSize: '18px'
    },
    inputRoot: {
      color: 'inherit',
      width: '100%',
      maxWidth: '300px',
      alignSelf: 'center'
    },
    inputInput: {
      padding: theme.spacing(1, 1, 1, 0),
      paddingLeft: `calc(${theme.spacing(2)}px)`,
      transition: theme.transitions.create('width'),
      width: '100%'
    },
    labelRoot: {
      color: 'inherit',
      width: '100%',
      maxWidth: '300px',
      alignSelf: 'center',
      paddingTop: '10px',
      paddingBottom: '5px',
      fontSize: '12px'
    },
    labelError: {
      color: 'red',
      alignSelf: 'center',
      fontSize: '12px'
    },
    customInputLabel: {
      "& legend": {
        visibility: "visible"
      }
    }
  }),
);

interface IProps {
  show: string,
  formState: any,
  formErrors: any,
  language: string,
  formChange: (e: ChangeEvent<HTMLInputElement>) => any,
  setFormValue: (name: string, value: any) => any,
  selectChange: (e: any) => any,
  formSubmit: () => any
}

const RegisterPrivate: React.FC<IProps> = ({
  show,
  formState,
  formErrors,
  language,
  formChange,
  setFormValue,
  selectChange,
  formSubmit
}) => {
  useEffect(() => { }, []);

  const classes = useStyles();
  const intl = useIntl();
  return (
    <Box m={3} display={show} justifyContent="center" >
      <Box width={300} alignItems="left">
        <InputLabel classes={{ root: classes.labelRoot }}><FormattedMessage id="register.name" />*</InputLabel>
        <OutlinedInput
          value={formState.name || ''}
          name="name"
          onChange={formChange}
          classes={{
            root: classes.inputRoot,
            input: classes.inputInput,
          }}
        />
        {formErrors.name ? ( <span className={classes.labelError}><FormattedMessage id={formErrors.name} /></span> ) :( null )}
        <InputLabel classes={{ root: classes.labelRoot }}><FormattedMessage id="register.surname" />*</InputLabel>
        <OutlinedInput
          value={formState.surname || ''}
          name="surname"
          onChange={formChange}
          classes={{
            root: classes.inputRoot,
            input: classes.inputInput,
          }}
        />
        {formErrors.surname ? ( <span className={classes.labelError}><FormattedMessage id={formErrors.surname} /></span> ) :( null )}
        <InputLabel classes={{ root: classes.labelRoot }}><FormattedMessage id="register.email" />*</InputLabel>
        <OutlinedInput
          value={formState.email || ''}
          name="email"
          onChange={formChange}
          classes={{
            root: classes.inputRoot,
            input: classes.inputInput,
          }}
        />
        {formErrors.email ? ( <span className={classes.labelError}><FormattedMessage id={formErrors.email} /></span> ) :( null )}
        <InputLabel classes={{ root: classes.labelRoot }}><FormattedMessage id="register.phone" />*</InputLabel>
        <OutlinedInput
          value={formState.phone || ''}
          name="phone"
          onChange={formChange}
          classes={{
            root: classes.inputRoot,
            input: classes.inputInput,
          }}
        />
        {formErrors.phone ? ( <span className={classes.labelError}><FormattedMessage id={formErrors.phone} /></span> ) :( null )}
        <RegisterAddressFields
          formState={formState}
          formErrors={formErrors}
          language={language}
          formChange={formChange}
          setFormValue={setFormValue}
        />
      <Box width={300} p={2} textAlign="center">
          <SecondaryButton labelText={intl.formatMessage({ id: "register.register" })} clickHandler={ () => formSubmit() } buttonEnabled={true} />
          </Box>
      </Box>
    </Box>
  );
};

export default (RegisterPrivate);
